var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillIconPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64209 0.736084V4.09215C8.64209 4.54719 8.64209 4.77471 8.73065 4.94852C8.80854 5.1014 8.93284 5.22569 9.08572 5.30359C9.25953 5.39215 9.48705 5.39215 9.94209 5.39215H13.2982M10.2671 9.45459H3.76709M10.2671 12.7046H3.76709M5.39209 6.20459H3.76709M8.64209 0.51709H4.41709C3.05196 0.51709 2.3694 0.51709 1.84799 0.782761C1.38934 1.01645 1.01645 1.38934 0.782761 1.84799C0.51709 2.3694 0.51709 3.05196 0.51709 4.41709V12.8671C0.51709 14.2322 0.51709 14.9148 0.782761 15.4362C1.01645 15.8948 1.38934 16.2677 1.84799 16.5014C2.3694 16.7671 3.05196 16.7671 4.41709 16.7671H9.61709C10.9822 16.7671 11.6648 16.7671 12.1862 16.5014C12.6448 16.2677 13.0177 15.8948 13.2514 15.4362C13.5171 14.9148 13.5171 14.2322 13.5171 12.8671V5.39209L8.64209 0.51709Z",
    stroke: "#ACB7C5",
    strokeWidth: 1.03409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillIconPlaceholder);
export default __webpack_public_path__ + "static/media/BillIconPlaceholder.276f5c1881becfcad8565603d1ef837c.svg";
export { ForwardRef as ReactComponent };